/* 交易商对比 */
import { get, post } from '~/assets/js/api/methods'
import apiList from '~/api.config.js'
const { testwikidatacenter, homeClient } = apiList // homeClient客户端, testwikidatacenter服务端

export default (axios) => ({
  compareInit: (params = {}) => post(axios, `${testwikidatacenter}/wikifxweb-v1/compare/index/init-v1`, params), // 交易商对比init初始化
  compare: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/compare/index/init-v1`, params), // 交易商对比init初始化
  // compareRank: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/compare/traderrank-v1`, params), // 交易商对比排名[弃用]
  // getRankList: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/compare/traderrank-v1`, params), // 交易商对比排名[弃用]
  compareSearch: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/trader/search-v1`, params), // 交易商搜索
  getUrlName: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/trader/urlname/init-v1`, params), // 获取交易商的code和urlName
  clientGetUrlName: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/trader/urlname/init-v1`, params) // 获取交易商的code和urlName
})
